export default {"src":"/_next/static/media/cardAndLetter_64.f2e5b7d9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};